import {API_URL} from '../../api/apiBase'
import {BidBaseModel, BidEditableModel, BidSubmitModel} from "@/src/components/bid/bidding_model";


export const getBid = async (project_id: string, bid_id: string, accessToken: string) => {
    return fetch(`${API_URL}/projects/${project_id}/bidding/${bid_id}`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    }).then((res) => res.json())
}



export async function updateBid(accessToken: string, project_id: string, bid_id: string, body: BidBaseModel) {
    return fetch(`${API_URL}/projects/${project_id}/bidding/${bid_id}/update`, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
        },
    }).then((res) => res.json())
}


// export async function deleteBid(accessToken: string, project_id: string, bid_id: string) {
//     return fetch(`${API_URL}/projects/${project_id}/bidding/${bid_id}/delete`, {
//         method: 'DELETE',
//         body: JSON.stringify({}),
//         headers: {
//             Authorization: `Bearer ${accessToken}`,
//             'Content-Type': 'application/json',
//         },
//     }).then((res) => res.json())
// }

